<template>
  <div :class="className" :id="id" :style="{ height: height, width: width }" />
</template>

<script>
import resize from "./mixins/resize";

export default {
  name: "SpotBottomLine",
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "170px"
    },
    chartData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      chart: null,
      legendColor: ["#f61b1f", "#ff7c1c", "#ffd716", "#92f630", "#357efe"]
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.option = {
        grid: {
          top: "4%",
          bottom: "20%",
          left: "3%",
          right: "12%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          data: this.chartData.line_data.map(function(item) {
            return item[0];
          }),
          axisLine: {
            lineStyle: {
              color: "#142439"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#cbeeff"
          }
        },
        yAxis: {
          axisLine: {
            show: false
          },
          axisLabel: {
            color: "#cbeeff"
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#142439",
              type: "dashed"
            }
          }
        },
        dataZoom: [
          {
            // startValue: "08-10-10:00",
            // endValue: "08-12-14:00",
            backgroundColor: "rgba(47,69,84,0)",
            fillerColor: "rgba(36,118,157,0.4)",
            borderColor: "#142439",
            dataBackground: {
              lineStyle: {
                color: "#00cdff"
              },
              areaStyle: {
                color: "#1a4b67"
              }
            },
            textStyle: {
              color: "#cbeeff"
            }
          }
        ],
        visualMap: {
          type: "piecewise",
          top: "10%",
          right: "1%",
          align: "left",
          textGap: 8,
          itemGap: 16,
          itemWidth: 10,
          itemHeight: 10,
          itemSymbol: "diamond",
          pieces: [
            {
              gt: this.chartData.legendConf[4].min,
              lte: this.chartData.legendConf[4].max,
              color: this.legendColor[4]
            },
            {
              gt: this.chartData.legendConf[3].min,
              lte: this.chartData.legendConf[3].max,
              color: this.legendColor[3]
            },
            {
              gt: this.chartData.legendConf[2].min,
              lte: this.chartData.legendConf[2].max,
              color: this.legendColor[2]
            },
            {
              gt: this.chartData.legendConf[1].min,
              lte: this.chartData.legendConf[1].max,
              color: this.legendColor[1]
            },
            {
              gt: this.chartData.legendConf[0].min,
              color: this.legendColor[0]
            }
          ],
          outOfRange: {
            color: "#999"
          },
          textStyle: {
            color: "#cbeeff"
          }
        },
        series: {
          type: "line",
          symbol: "none",
          smooth: true,
          data: this.chartData.line_data.map(function(item) {
            return item[1];
          })
        }
      };

      this.chart = this.$echarts.init(document.getElementById(this.id));
      this.chart.setOption(this.option);
    }
  }
};
</script>
<style scoped lang="less"></style>
